import Log from './pages/Log';
import AppHeader from './components/AppHeader';

function App() {
  return (
    <div className="app-shell">
      <div className="app-aurora" />
      <AppHeader />
      <main className="app-main">
        <Log />
      </main>
    </div>
  );
}

export default App;
